export const AAD_LOGIN_SUCCESS = 'AAD_LOGIN_SUCCESS';
export const AAD_LOGOUT_SUCCESS = 'AAD_LOGOUT_SUCCESS';
export const AAD_LOGIN_FAILED = 'AAD_LOGIN_FAILED';
export const AAD_LOGIN_ERROR = 'AAD_LOGIN_ERROR';
export const AAD_AUTHENTICATED_STATE_CHANGE = 'AAD_AUTHENTICATED_STATE_CHANGED';
export const AAD_ACQUIRED_ID_TOKEN_SUCCESS = 'AAD_ACQUIRED_ID_TOKEN_SUCCESS';
export const AAD_ACQUIRED_ACCESS_TOKEN_ERROR = 'AAD_ACQUIRED_ACCESS_TOKEN_ERROR';
